import _ from "lodash";
import React from "react";
import classes from "./TaggedStudentDetails.scss";
import { compose } from "lib/apolloClient";
import { connect } from "react-redux";
import ProfileCascade from "UIComponents/ProfileCascade";
import I18nHOC from "UIComponents/I18nHOC";
import MoreItemWithToolTip from "UIComponents/MoreItemWithToolTip";
import { getDefaultStudentNameOrderPreference } from "modules/CommonSelectors";
import { getFormattedStudentName } from "Utils/GetFormattedStudentName";

const ProfileCadeStyle = {
  width: 32,
  height: 32,
  marginRight: 4,
};

const avatarStyle = {
  size: "small",
  shade: "light",
  randomizeColor: true,
};
const BLANK_OBJECT = {};
const getProfileCascadeItems = ({
  students,
  defaultStudentNameOrderPreference,
}) => {
  return _.map(students, student => {
    const { id, profileImage } = student.node;
    return {
      id: id,
      value: _.startCase(
        getFormattedStudentName({
          student: _.get(student, "node", {}),
          isFormattedNameV2: true,
          defaultStudentNameOrderPreference,
        })
      ),
      imageUrl: profileImage,
    };
  });
};

class TaggedStudentDetails extends React.PureComponent {
  render() {
    const {
      taggedStudents = [],
      t,
      customProfileCadeStyle,
      customStudentNameStyle,
      containerStyle = {},
      defaultStudentNameOrderPreference,
    } = this.props;
    const moreLength = 1;

    const studentItems = _.map(taggedStudents, item => ({
      name: _.startCase(
        getFormattedStudentName({
          student: _.get(item, "node", {}),
          isFormattedNameV2: true,
          defaultStudentNameOrderPreference,
        })
      ),
      isArchived: _.get(item, "node.isArchived"),
    }));

    const taggedProfiles = getProfileCascadeItems({
      students: taggedStudents,
      defaultStudentNameOrderPreference,
    });
    return (
      <div className={classes.container} style={containerStyle}>
        <ProfileCascade
          items={taggedProfiles}
          customStyle={
            customProfileCadeStyle ? customProfileCadeStyle : ProfileCadeStyle
          }
          length={moreLength}
          showAvatar={taggedProfiles?.length >= 1}
          avatarStyles={avatarStyle}
        />
        <div
          className={classes.tagStudentNameContainer}
          style={customStudentNameStyle ? customStudentNameStyle : BLANK_OBJECT}
        >
          <MoreItemWithToolTip
            items={_.map(studentItems, student => _.get(student, "name"))}
            tooltipPlacement={"bottom"}
            length={moreLength}
            noItemText={t("common:no_students_selected")}
            trigger={["hover"]}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const defaultStudentNameOrderPreference = getDefaultStudentNameOrderPreference(
    state
  );
  return {
    defaultStudentNameOrderPreference,
  };
};

export default compose(
  I18nHOC({ resource: ["common"] }),
  connect(mapStateToProps, null)
)(TaggedStudentDetails);
